import React from "react";
import LegalLayout from "../../components/LegalLayout";

export default function GDPR() {
  return (
    <LegalLayout
      title="Data Protection (GDPR)"
      seoPath="/gdpr"
      intro="Jollof Fit Kingdom is committed to protecting personal data in accordance with the EU General Data Protection Regulation (GDPR) and other applicable data protection laws. This page explains how we comply and the rights available to individuals in the European Economic Area (EEA) and the UK."
      sections={[
        {
          heading: "Data Controller",
          body: ["Jollof Fit Kingdom acts as the data controller for personal data processed through the Services. For data protection inquiries, you can contact us using the details at the bottom of this page."],
        },
        {
          heading: "Data We Process",
          body: ["Depending on how you use the Services, we may process the following categories of personal data:"],
          list: [
            "Account and contact information.",
            "Health and fitness data, including workouts, activity, steps and goals.",
            "Nutrition data such as meals, food logs, macros and hydration.",
            "Body composition and connected-device data.",
            "Progress photos you choose to add.",
            "Voice and audio input when you use voice features with your Coach.",
            "Subscription information from supported app stores.",
            "Usage and analytics data.",
          ],
        },
        {
          heading: "Lawful Bases for Processing",
          body: ["We process personal data only where we have a lawful basis to do so."],
          list: [
            "Consent — for example when you connect health devices, enable voice features or opt into communications.",
            "Contract — to provide the Services you request.",
            "Legitimate interests — to secure, operate and improve the Services.",
            "Legal obligation — to comply with applicable laws.",
          ],
        },
        {
          heading: "Special Category Data",
          body: ["Health, body composition and progress-photo data is considered special category data under the GDPR. We process such data only with your explicit consent or another valid legal basis, and apply enhanced safeguards to protect it."],
        },
        {
          heading: "Your GDPR Rights",
          list: [
            "Right to access your personal data.",
            "Right to rectification of inaccurate data.",
            "Right to erasure ('right to be forgotten').",
            "Right to restrict or object to processing.",
            "Right to data portability.",
            "Right to withdraw consent at any time.",
            "Right to lodge a complaint with a supervisory authority.",
          ],
        },
        {
          heading: "International Data Transfers",
          body: ["Where we transfer personal data outside the EEA or UK, we rely on appropriate safeguards such as Standard Contractual Clauses or adequacy decisions to ensure your data remains protected."],
        },
        {
          heading: "Account & Data Deletion",
          body: ["You can request deletion of your account and personal data at any time using the contact details below or via our Account & Data Deletion page. We action deletion requests in line with applicable law and any legitimate legal or data-retention obligations."],
        },
        {
          heading: "Data Retention",
          body: ["We retain personal data only for as long as necessary for the purposes described in our Privacy Policy or as required by law, after which it is deleted or anonymized."],
        },
        {
          heading: "Data Security",
          body: ["We apply technical and organizational measures — including encryption in transit, access controls and ongoing monitoring — designed to protect personal data against unauthorized access, alteration or loss."],
        },
        {
          heading: "Exercising Your Rights",
          body: ["To exercise any of your rights or ask questions about how we handle your data, contact us using the details below. We will respond within the timeframes required by applicable law."],
        },
      ]}
    />
  );
}
